import type { LocalVideoTrack } from 'livekit-client'
import { useTranslation } from 'react-i18next'

import { useBackgroundModelLoading } from '@/src/hooks/room/track/useBackgroundModelLoading'
import { Spinner } from './Spinner'
import styles from './BackgroundModelLoading.module.css'

/** Затемняет и размывает камеру на время загрузки и включения модели фона.
 * @param track — локальная камера; удалённые камеры и демонстрация экрана не передаются.
 */
export function BackgroundModelLoading({ track }: { track?: LocalVideoTrack }) {
  const loading = useBackgroundModelLoading(track)
  const { t } = useTranslation()

  if (!loading) return null

  return (
    <div className={styles.overlay} role="status" aria-label={t('backgroundModelLoading')}>
      <span className={styles.spinner} aria-hidden="true">
        <Spinner color="#fff" width={32} />
      </span>
    </div>
  )
}
